export const shadows = {
  small: '0px 2px 24px rgba(0, 0, 0, 0.08)',
  pressed: '0px 1px 8px rgba(0, 0, 0, 0.12)',
  default: '0px 2px 16px rgba(0, 0, 0, 0.16)',
  stickyBottom: '0px -8px 16px rgba(0, 0, 0, 0.32)',
}
